<div id='status-root'>
  <span [ngClass]='this.status?.toLowerCase()'>
    {{ status }}
  </span>
</div>
